import { useNavigate } from "react-router-dom";
import "../../scss/Common.scss";
import "../../scss/ListView.scss";
import WideTile from "./WideTile";
export default function WideTileListView({
  data,
  keyWord,
}: {
  data: any;
  keyWord: string;
}) {
  const nav = useNavigate();
  return (
    <div className="space-y-4 mt-8 mb-8 ">
      {data
        ?.filter((data: any) => data.is_open)
        .map((data: any) => {
          let imageUrl = undefined;
          if (Array.isArray(data.images) && data.images.length > 0) {
            const sorted = [...data.images].sort((a, b) => a.index - b.index);
            imageUrl = sorted[0]?.url;
          }
          return (
            <WideTile
              key={data.id}
              url={imageUrl}
              name={data.name}
              description={data.description}
              onClick={() => nav(`/${keyWord}/${data.id}`)}
            />
          );
        })}
    </div>
  );
}
